import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";

import { ASPECT_RATIOS, FORMATS } from "../../constants";
import { useImagePostModalStore } from "../../store";

const croppingOptionLabels = {
  square: () =>
    t("image_space.post_modal.steps.adjust_images.cropping_options.square"),
  portrait: () =>
    t("image_space.post_modal.steps.adjust_images.cropping_options.portrait"),
  landscape: () =>
    t("image_space.post_modal.steps.adjust_images.cropping_options.landscape"),
};

const formatsData = [
  {
    format: FORMATS.SQUARE,
    iconName: "aspect-ratio-11",
  },
  {
    format: FORMATS.PORTRAIT,
    iconName: "aspect-ratio-34",
  },
  {
    format: FORMATS.LANDSCAPE,
    iconName: "aspect-ratio-169",
  },
] as const;

export const CroppingOptions = () => {
  const { galleryAspectRatio, setGalleryAspectRatio } =
    useImagePostModalStore();

  const selectedFormat = Object.entries(ASPECT_RATIOS).find(
    ([, aspectRatio]) => aspectRatio === galleryAspectRatio,
  )?.[0];

  return (
    <div className="flex justify-between">
      {formatsData.map(({ format, iconName }) => {
        const isSelected = selectedFormat === format;

        return (
          <Tooltip content={croppingOptionLabels[format]()} key={format}>
            <IconButton
              aria-label={croppingOptionLabels[format]()}
              aria-pressed={isSelected}
              icon={iconName}
              onClick={() => {
                setGalleryAspectRatio(ASPECT_RATIOS[format]);
              }}
              size="sm"
              type="button"
              variant={isSelected ? "outline" : "ghost"}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};
